
// Add locales you want supported by Angular
// Default locales as supported by PBI
// https://docs.microsoft.com/en-us/power-bi/developer/visuals/localization#supported-languages

import '@angular/common/locales/global/ar';
import '@angular/common/locales/global/ar-SA';
import '@angular/common/locales/global/bg';
import '@angular/common/locales/global/ca';
import '@angular/common/locales/global/cs';
import '@angular/common/locales/global/da';
import '@angular/common/locales/global/de';
import '@angular/common/locales/global/el';
import '@angular/common/locales/global/en';
import '@angular/common/locales/global/en-GB';
import '@angular/common/locales/global/es';
import '@angular/common/locales/global/et';
import '@angular/common/locales/global/eu';
import '@angular/common/locales/global/fi';
import '@angular/common/locales/global/fr';
import '@angular/common/locales/global/gl';
import '@angular/common/locales/global/he';
import '@angular/common/locales/global/hi';
import '@angular/common/locales/global/hr';
import '@angular/common/locales/global/hu';
import '@angular/common/locales/global/id';
import '@angular/common/locales/global/it';
import '@angular/common/locales/global/ja';
import '@angular/common/locales/global/kk';
import '@angular/common/locales/global/ko';
import '@angular/common/locales/global/lt';
import '@angular/common/locales/global/lv';
import '@angular/common/locales/global/ms';
import '@angular/common/locales/global/nb';
import '@angular/common/locales/global/nl';
import '@angular/common/locales/global/pl';
import '@angular/common/locales/global/pt';
import '@angular/common/locales/global/pt';
import '@angular/common/locales/global/ro';
import '@angular/common/locales/global/ru';
import '@angular/common/locales/global/sk';
import '@angular/common/locales/global/sl';
import '@angular/common/locales/global/sr-Cyrl';
import '@angular/common/locales/global/sr-Latn';
import '@angular/common/locales/global/sv';
import '@angular/common/locales/global/th';
import '@angular/common/locales/global/tr';
import '@angular/common/locales/global/uk';
import '@angular/common/locales/global/vi';
import '@angular/common/locales/global/zh';
